import { render, staticRenderFns } from "./createProduct.pug?vue&type=template&id=52a89132&lang=pug&"
import script from "./createProduct.ts?vue&type=script&lang=ts&"
export * from "./createProduct.ts?vue&type=script&lang=ts&"
import style0 from "./createProduct.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports